import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getCreatedKey } from 'store/selectors/apiKeys';
import { removeCreatedKey } from 'store/actions/apiKeys';
import ShowCreatedApiKey from './ShowCreatedApiKey';

const selector = createStructuredSelector({
  createdApiKey: getCreatedKey,
});

const actions = {
  onRemoveCreatedKey: removeCreatedKey,
};

export default connect(
  selector,
  actions,
)(ShowCreatedApiKey);
